<template>
  <div>
    <span class="label" v-if="inTemplate">
      {{ isActive ? "Inactivar secuencia" : "Activar secuencia" }}
    </span>

    <a-tooltip placement="bottom" :title="isActive ? 'Inactivar' : 'Activar'">
      <a-switch
        name="chatbot-switch"
        :checked="isActive"
        :loading="loadingSwitch"
        :disabled="disabled"
        @change="handleChangeStatus"
        size="small"
      />
    </a-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { ResponseError } from "@/app/shared/utils/httpManager";
import { Sequence, SequenceStatus } from "@/@types/flows/sequences";
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";

const props = defineProps<{
  sequence: Sequence;
  inTemplate?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  update: [];
}>();

const loadingSwitch = ref(false);
const isActive = computed(() => props.sequence.status === SequenceStatus.Active);

const handleUpdate = () => emit("update");

const handleChangeStatus = async () => {
  loadingSwitch.value = true;

  try {
    if (isActive.value) {
      await new Promise((res) => {
        Modal.confirm({
          centered: true,
          icon: createVNode(QuestionCircleOutlined),
          title: `¿Estás seguro de inactivar “${props.sequence.name}”?`,
          content: "Recuerda que puedes volver a activar esta secuencia cuando desees.",
          okText: "Inactivar",
          onOk: async () => {
            await sequenceService.toggleState(props.sequence);
            message.success("Se ha inactivado tu secuencia con éxito");
            res(undefined);
          },
          onCancel: () => {
            loadingSwitch.value = false;
          },
        });
      });
    } else {
      await sequenceService.toggleState(props.sequence);

      message.success("Se ha activado tu secuencia con éxito");
    }

    handleUpdate();
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) errorMessage = error.getErrorMessage(undefined, false);

    message.warning(errorMessage);
    console.error(error);
  }

  loadingSwitch.value = false;
};
</script>

<style lang="sass" scoped>
.label
  margin-right: 5px
  font-size: 12px
  color: $gray-8

// .floating
//   position: absolute
//   right: 0
//   top: 0
//   bottom: 0
//   margin: auto 0
//   display: flex
//   align-items: center
//   margin-right: 12px
</style>
